import { lazy } from "react";
const ScamBlog = lazy(() => import("./scams"));
const MoneyTransfer = lazy(() => import("./moneyTransfer"));
const PropertyOverseas = lazy(() => import("./propertyOverseas"));
const ThailandBlog = lazy(() => import("./thailandBlog"));
export { ScamBlog, MoneyTransfer, PropertyOverseas, ThailandBlog };
